import { useAuth } from './useAuth';
import { translations } from '../lib/i18n';
import type { Language } from '../lib/i18n';
import { useLanguage } from '../contexts/LanguageContext';

export const useTranslation = () => {
    const { session } = useAuth();
    const { language: contextLanguage } = useLanguage();
    
    // If user is authenticated and has a language preference, use it
    // Otherwise, use the context language (browser detected or manually selected)
    const lang: Language = session.user?.language || contextLanguage;
    const t = translations[lang];

    return {
        t,
        lang,
    };
};
